export const environment = {
  mainTitle: 'Dashboard',
  production: true,
  apiUrl: 'https://energyshift.247boxz.nl/api',
  socketUrl: 'https://energyshift.247boxz.nl',
  socketPort: 23100,
  JWT_STORAGE_KEY: 'token',
};
